import React, { useRef, useState } from 'react'
import Options from './Options'

//modals
import Question from '../../../../modals/messages/Question'
import Error from '../../../../modals/messages/Error'
import EditPart from '../modals/AddEditPart'

// images
import loader from '../../../../../assets/img/loader.svg'
import markDevicesImage from "@/assets/img/reservations/icons/give-parts.svg"

import Api from '../../../../../_helpers/Api'
import checkIcon from '../../../../../assets/img/icons/check.png'
import crossIcon from '../../../../../assets/img/icons/close.png'
import { trans } from '../../../../../_providers/Translation'
import TableFiles from './TableFiles'
import { useCurrencyContext } from '../../../../../_providers/Currency'
import { Checkbox, FormControlLabel } from '@mui/material'
import moment from 'moment'
import DeviceOptions from './DeviceOptions'

function DevicesTable(props) {
    const currencies = useCurrencyContext()

    const [loadingGiven, setLoadingGiven] = useState(false)

    const { data: devices } = props.devices || []
    //refs
    const questionModalRef = useRef(null)
    const errorModalRef = useRef(null)
    const editPartModalRef = useRef(null)

    const reservation = props.reservation

    const handleDeleteDevice = id => {
        let modal = questionModalRef.current

        modal.open(id)

        modal.onSuccess(() => {
            props.handleDeleteDevice(id)
        })
    }

    const handleEditPart = id => {

        let modal = editPartModalRef.current

        modal.edit(id)

        modal.onSave(part => {
            props.handleUpdateDevice(part)
        })

    }

    const handleTransferAll = e => {
        let date = document.getElementById('give-date').value

        if (props.selectedDevicesIds.length) {
            setLoadingGiven(true)

            Api.post('reservations/devices/given', {
                ids: props.selectedDevicesIds,
                date: date
            }).then(res => {
                props.refreshData()
            })
                .finally(() => {
                    setLoadingGiven(false)
                })
        }
    }

    const markToIncludeInOffer = (e, id) => {
        props.setSelectedDevicesIds(prev =>
            e.target.checked ? [...prev, id] : prev.filter(x => x !== id)
        )
    }

    const includeAllInOffer = (e) => {
        const checked = e.target.checked

        if (checked) {
            const allIds = props.data.map(row => row.id)
            props.setSelectedDevicesIds(allIds)
        } else {
            props.setSelectedDevicesIds([])
        }
    }

    const includeLabourInQuote = () => {
        props.setToIncludeLabourInQuote(prev => !prev)
    }

    return (

        props.loading
            ?
            <img src={loader} alt="loading" />
            :
            <>
                <Question
                    ref={questionModalRef}
                    mainMessage={trans('headings.question16')}
                />

                <Error
                    ref={errorModalRef}
                    mainMessage={trans('headings.error3')}
                />

                <EditPart
                    ref={editPartModalRef}
                    reservation={reservation}
                />

                {props.data.length == 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noResultsFound')}
                    </div>
                    :
                    <>
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        {/* YK: ЧАСТИ - 7а */}
                                        <th className="checkbox">
                                            <Checkbox
                                                checked={props.selectedDevicesIds.length > 0 && props.selectedDevicesIds.length === props.data.length}
                                                indeterminate={props.selectedDevicesIds.length > 0 && props.selectedDevicesIds.length < props.data.length}
                                                onChange={(e) => includeAllInOffer(e)}
                                                size='small'
                                            />
                                        </th>
                                        <th>ID</th>
                                        <th>{trans('tables.name')}</th>
                                        <th>{trans('tables.partNumber')}</th>
                                        <th>{trans('tables.source')}</th>
                                        <th>{trans('tables.grossPrice')}</th>
                                        <th className="center">{trans('tables.given')}</th>
                                        <th className="options">
                                            {props.reservation.can_modify && props.reservation.can_modify_devices &&
                                                <th className="options">{trans('tables.options')}</th>
                                            }
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.data.map(row =>
                                        <tr key={'p-' + row.id}>
                                            <td
                                                className="checkbox"
                                                style={{
                                                    paddingLeft: '20px'
                                                }}
                                            >
                                                <Checkbox
                                                    className="mark-offer"
                                                    checked={props.selectedDevicesIds.includes(row.id)}
                                                    onChange={(e) => markToIncludeInOffer(e, row.id)}
                                                    data-id={row.id}
                                                    size='small'
                                                />
                                            </td>
                                            <td>
                                                {row.id}
                                            </td>
                                            <td>
                                                {row.product?.name || '-'}
                                            </td>
                                            <td>
                                                {row.product?.number || '-'}
                                            </td>
                                            <td>
                                                {row.source === 'SERVICE'
                                                    ? trans('random.sourceService')
                                                    : row.source === 'EMPLOYEE'
                                                        ? trans('random.sourceEmployee')
                                                        :
                                                        '-'
                                                }
                                            </td>

                                            <td>
                                                {row.gross_price_format || '0.00'} {row.currency.name}
                                            </td>

                                            <td className="center">
                                                {row.given_date && <img src={checkIcon} alt="given" height="8" />}
                                            </td>
                                            {props.reservation.can_modify &&
                                                <td
                                                    style={{
                                                        paddingRight: '20px'
                                                    }}
                                                    className="options"
                                                >
                                                    <DeviceOptions
                                                        id={row.id}
                                                        number={row.product?.number}
                                                        deletable={row.deletable}
                                                        handleDeleteDevice={handleDeleteDevice}
                                                        handleEditPart={handleEditPart}
                                                    />
                                                </td>
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <hr />
                            <div
                                className='row'
                                style={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div>
                                    <div
                                        className='row'
                                        style={{
                                            gap: "10px",
                                            alignItems: "center"
                                        }}
                                    >
                                        <input
                                            id="give-date"
                                            type="datetime-local"
                                            defaultValue={moment().format("YYYY-MM-DDTHH:mm")}
                                        />
                                        <button
                                            onClick={handleTransferAll}
                                            className='button button-default button-small'
                                            disabled={(props.selectedDevicesIds || []).length === 0 || loadingGiven}
                                        >
                                            <img src={markDevicesImage} alt="mark devices" />
                                            {trans('random.markUp')}
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(e) => includeLabourInQuote()}
                                                size='small'
                                            />
                                        }
                                        label={`${trans('labels.includeLabourInQuote2')} (+${parseFloat(props.reservation.labour_price).toFixed(2)} ${currencies.find(c => c.id === props.reservation.currency_id)?.name || ''}).`}
                                        sx={{
                                            paddingLeft: '12px',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }

            </>

    )
}

export default DevicesTable